<template>
  <div class="container" v-if="!loading" style="height:100vh;display:flex;flex-direction:column;justify-content:center;padding:10px">
    <span style="color: #9e9e9e;font-size:16px">
      <span v-if="instanceVersion.length" style="color:black">({{instanceVersion}})</span>
    </span>
    <select class="select" v-on:change="getQR()" ref="instancePicker">
      <option value="" disabled selected>Select Instance</option>
      <option
        v-for="(instance,index) in instances"
        :key="index"
        v-bind:value="instance"
      >{{instance}}</option>
    </select>
    <div class="row" style="width:100%">
      <div class="col m8 s12 offset-m2">
        <div class="card" style="width:350px">
          <div class="card-image" v-if="dataPackageAvailabe">
            <img id="image" :src="qr" v-on:load="loaded()" style="max-height:350px;max-width:350px" />
            <div id="progress" class="valign-wrapper">
              <div class="preloader-wrapper active" style="margin: auto">
                <div class="spinner-layer spinner-red-only">
                  <div class="circle-clipper left">
                    <div class="circle"></div>
                  </div>
                  <div class="gap-patch">
                    <div class="circle"></div>
                  </div>
                  <div class="circle-clipper right">
                    <div class="circle"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else style="padding:10px;font-weight:700;text-align:center;color:red">No data package available to scan</div>
          <div class="card-content">
            <span class="card-title">New device</span>
            <p>Scan the QR-code with the Helen-app to activate the new device.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
#image {
  opacity: 0;
  transform: scale(0);
  transition: 0.6s ease-in-out;
}
#progress {
  width: 100%;
  height: 600px;
}
</style>
<script>
export default {
  name: "devices",
  data() {
    return {
      qr: "",
      loading: true,
      instances: [],
      instanceVersion: "",
      dataPackageAvailabe:false,
    };
  },
  mounted() {
    this.$http.get("dialogs?tag=start").then((r) => {
      if (r.data) {
        r.data.forEach((instance) => {
          if (instance.tags)
            for (let i = 0; i < instance.tags.length; i++) {
              if (instance.tags[i].includes("start_")) {
                this.instances.push(instance.tags[i]);
                break;
              }
            }
        });
        this.loading = false;
        // this.getQR();
      }
    });
  },
  updated() {
    if (this.$el != null) {
      const selector = this.$el.querySelector("select");
      if (selector) {
        M.FormSelect.init(selector, {});
      }
    }
  },
  methods: {
    showVersion(instance) {
      this.instanceVersion = "";
      this.$http
        .get("/settings/dataupdate?instance=" + instance + "&version=0")
        .then((r) => {
          if (r.data.status) {
            if (r.data.data){
              this.instanceVersion = "Data version " +
                r.data.data.version +
                " available, posted on " +
                new Date(r.data.data.created).toLocaleString();
              this.dataPackageAvailabe = true;
            }
            else
            this.dataPackageAvailabe = false;
          }
        });
    },
    loaded() {
      document.querySelector("#progress").style.display = "none";
      document.querySelector("#image").style.opacity = 1;
      document.querySelector("#image").style.transform = "scale(1)";
    },
    getQR() {
      var instance = this.$refs.instancePicker
        ? this.$refs.instancePicker.value
        : this.instances[0];
      this.showVersion(instance);
      this.qr = "";
      if (document.querySelector("#progress"))
        document.querySelector("#progress").style.display = "flex";
      this.$http({
        method: "post",
        url: "auth/qrhelen",
        data: {
          languages: 1,
          dialogs: 1,
          phrases: 1,
          settings: 1,
          userrecord: 1,
          stats: 2,
        },
        headers: {
          instance: instance,
        },
        responseType: "blob",
      }).then((response) => {
        var reader = new window.FileReader();
        reader.readAsDataURL(response.data);
        reader.onload = () => {
          this.qr = reader.result;
        };
      });
    },
  },
  created() {
    // this.getQR();
  },
};
</script>